module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10025.089fde50.jpg";